import behaviors from './behaviors';
function getBehavior(content) {
  return behaviors[content.getAttribute('data-collapsible-behavior') || 'none'];
}
function getTriggers(content) {
  let triggers = [];
  if (content.id) {
    triggers = Array.prototype.slice.call(document.querySelectorAll(`.sib-collapsible__trigger[aria-owns~="${content.id}"],` + `.sib-collapsible__trigger[aria-controls~="${content.id}"]`));
  }
  const collapsible = content.closest('.sib-collapsible');
  if (collapsible) {
    triggers.push(collapsible.querySelector('.sib-collapsible__trigger'));
  }
  if (!triggers.length) {
    throw new Error('Collapsible content does not have associated trigger.');
  }
  return triggers;
}
function toggle(trigger, content) {
  const behavior = getBehavior(content);
  const visible = behavior.shouldBeHidden(content);
  if (trigger.hasAttribute('aria-expanded')) {
    trigger.setAttribute('aria-expanded', !visible);
  }
  visible ? behavior.hide(content) : behavior.show(content);
  trigger.classList.toggle('sib-collapsible__trigger_toggled');
  content.classList.toggle('sib-collapsible__content_toggled');
}
function hideContent(content) {
  getBehavior(content).hide(content);
  content.classList.toggle('sib-collapsible__content_toggled');
  getTriggers(content).forEach(trigger => {
    trigger.hasAttribute('aria-expanded') && trigger.setAttribute('aria-expanded', 'false');
    trigger.classList.toggle('sib-collapsible__trigger_toggled');
  });
}
function getContent(trigger) {
  const controls = trigger.getAttribute('aria-controls');
  const owns = trigger.getAttribute('aria-owns');
  let ids = [];
  if (controls) {
    ids = ids.concat(controls.split(' '));
  }
  if (owns) {
    ids = ids.concat(owns.split(' '));
  }
  for (let i = 0; i < ids.length; i++) {
    const id = ids[i];
    const element = document.getElementById(id);

    // if (!element) {
    // 	continue;
    // }

    if (element && element.matches('.sib-collapsible__content')) {
      return element;
    }
  }
  const collapsible = trigger.closest('.sib-collapsible');
  if (!collapsible) {
    throw new Error('Collapsible trigger outside of collapsible wrapper.');
  }
  return collapsible.matches('.sib-collapsible__content') ? collapsible : collapsible.querySelector('.sib-collapsible__content');
}
export function addBehavior(name, behavior) {
  behaviors[name] = behavior;
}
export const onCollapsable = e => {
  if (e.button) {
    return;
  }
  let contentsToHide = [];
  const contents = document.querySelectorAll('.sib-collapsible__content_touchy');
  let content;
  for (let i = 0; i < contents.length; ++i) {
    content = contents[i];
    if (getBehavior(content).shouldBeHidden(content)) {
      contentsToHide.push(content);
    }
  }
  const trigger = e.target.closest('.sib-collapsible__trigger:not([type=radio])');
  content = trigger ? getContent(trigger) : e.target.closest('.sib-collapsible__content');
  if (content) {
    contentsToHide = contentsToHide.filter(contentToHide => {
      return !contentToHide.contains(content);
    });
  }
  if (trigger) {
    // do not prevent user to open link in new tab if the trigger is a link
    if (trigger.tagName === 'A') {
      if (e.ctrlKey) {
        return;
      }
      e.preventDefault();
    }
    toggle(trigger, content);
  }
  contentsToHide.forEach(hideContent);
};